(function () {
    'use strict';

    const language = (document.documentElement.lang ||
        (window.location.hostname.endsWith('.fr') ? 'fr' : 'de')).toLowerCase().split('-')[0];
    if (language !== 'fr' && language !== 'de') return;

    const selector = '.notification-preview-text';
    const pending = new Set();
    let frame = 0;

    function translateText(root, transform) {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
            const translated = transform(node.nodeValue);
            if (translated !== node.nodeValue) node.nodeValue = translated;
        }
    }

    function translate(block) {
        const paragraphs = block.querySelectorAll('p');
        if (paragraphs.length < 3) return;
        translateText(paragraphs[0], text => language === 'fr'
            ? text.replace(/ hat gekauft:/g, ' a acheté :').replace(/ in /g, ' à ')
            : text.replace(/ a acheté :/g, ' hat gekauft:').replace(/ à /g, ' in '));
        translateText(paragraphs[2], text => language === 'fr'
            ? text.replace(/\bvor\b/g, 'il y a').replace(/Stunde\(n\)/g, 'heure(s)')
            : text.replace(/il y a/g, 'vor').replace(/heure\(s\)/g, 'Stunde(n)'));
    }

    function flush() {
        frame = 0;
        const blocks = Array.from(pending);
        pending.clear();
        blocks.forEach(block => {
            if (block.isConnected) translate(block);
        });
    }

    function queue(block) {
        pending.add(block);
        if (!frame) frame = requestAnimationFrame(flush);
    }

    function collect(node, includeDescendants) {
        const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
        if (!element) return;
        const block = element.closest(selector);
        if (block) queue(block);
        if (includeDescendants && node.nodeType === Node.ELEMENT_NODE && !block) {
            element.querySelectorAll(selector).forEach(queue);
        }
    }

    function start() {
        document.querySelectorAll(selector).forEach(translate);
        const observer = new MutationObserver(records => {
            records.forEach(record => {
                collect(record.target, false);
                record.addedNodes.forEach(node => collect(node, true));
            });
        });
        observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
        start();
    }
})();
